import { makeRequest } from '../../../../lib/api';
import { InsertTireDefectInterface, UpdateTireDefectInterface } from '../../api/tireDefectsApi';

const ORDER_TIRE_DEFECTS = '/v1/tire_defects';
const ORDER_TIRE_STORAGE = '/v1/tire_storage';
const tireDefectsController = {
  getTireDefects: (orderId: string): Promise<any> => {
    return makeRequest('get', `${ ORDER_TIRE_DEFECTS }?orderId=${ orderId }`);
  },

  addTireDefect: (request: InsertTireDefectInterface): Promise<any> => {
    return makeRequest('post', `${ ORDER_TIRE_DEFECTS }`, request);
  },

  updateTireDefect: (request: UpdateTireDefectInterface): Promise<any> => {
    return makeRequest('put', `${ ORDER_TIRE_DEFECTS }/${ request.id }`, request);
  },

  checkBarcode: (barcode: string, id?:string): Promise<any> => {
    const excludedParam = id ? `&excludedId=${ id }` : '';
    return makeRequest('get', `${ ORDER_TIRE_DEFECTS }/barcode_check?barcode=${ barcode }${ excludedParam }`);
  },

  getPdfWithQRCodes: (count: number): Promise<any> => {
    return makeRequest('get', `${ ORDER_TIRE_STORAGE }/qr_code/generate_pdf/${ count }`, {}, {
      responseType: 'blob',
    });
  },
};

export { tireDefectsController };
